module.exports = __webpack_public_path__ + "assets/img/main-logo-tangshan.60a463e4.png";